import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@core/services/http-call.service';
import {
  IApprovalRole,
  IFormTriggerAlertListResponse,
  IFormTriggerInfo,
  IGetFormTriggerAlertsRequest,
  IMonitorableFieldInfo,
  ISaveFormTriggerRequest
} from '@app/models/form-triggers/form-trigger.model';
import { Observable } from 'rxjs';

const HttpServiceMethods = {
  GetTriggers: 'FormTrigger/GetTriggers',
  GetApprovalRoles: 'FormTrigger/GetApprovalRoles',
  SaveTrigger: 'FormTrigger/SaveTrigger',
  DeleteTrigger: 'FormTrigger/DeleteTrigger',
  GetMonitorableFields: 'FormTrigger/GetMonitorableFields',
  GetAlerts: 'FormTriggerAlert/GetAlerts',
  ResolveAlert: 'FormTriggerAlert/ResolveAlert',
  GetOpenAlertCount: 'FormTriggerAlert/GetOpenAlertCount'
};

@Injectable({
  providedIn: 'root'
})
export class FormTriggerService {

  constructor(private httpService: HttpCallService) { }

  public getTriggers(): Observable<IFormTriggerInfo[]> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetTriggers
    );
  }

  public saveTrigger(request: ISaveFormTriggerRequest): Observable<string> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SaveTrigger,
      request
    );
  }

  public deleteTrigger(triggerGuid: string): Observable<boolean> {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.DeleteTrigger + `/${triggerGuid}`
    );
  }

  public getApprovalRoles(): Observable<IApprovalRole[]> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetApprovalRoles
    );
  }

  public getMonitorableFields(formType: number): Observable<IMonitorableFieldInfo[]> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetMonitorableFields + `/${formType}`
    );
  }

  public getAlerts(request: IGetFormTriggerAlertsRequest): Observable<IFormTriggerAlertListResponse> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.GetAlerts,
      request
    );
  }

  public resolveAlert(alertGuid: string, note: string): Observable<boolean> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.ResolveAlert,
      { alertGuid, note }
    );
  }

  public getOpenAlertCount(): Observable<number> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetOpenAlertCount
    );
  }
}
